var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTableCommon',{staticStyle:{"max-height":"100%","overflow":"auto"},attrs:{"type":"publication-formdata-history","list":_vm.history,"loading":_vm.isLoading,"skeleton":_vm.isLoadingAsyncData}})}
var staticRenderFns = []

export { render, staticRenderFns }